import React from "react";
import "./QuestionInputModal.scss";

export const QuestionInputModal = ({ setModalOpen }) => (
  <div className="modal is-active">
    <div className="modal-background"></div>
    <div className="modal-card">
      <header className="modal-card-head">
        <p className="modal-card-title">Vielen Dank!</p>
        <button className="delete" aria-label="close" onClick={() => setModalOpen(false)}></button>
      </header>
      <section className="modal-card-body">
        Deine Frage wird in kurze von unserem Team geprüft, um anschließend in den Fragenpool aufgenommen zu werden.
      </section>
      <footer className="modal-card-foot">
        <button className="button is-success" onClick={() => setModalOpen(false)}>
          Okay
        </button>
      </footer>
    </div>
  </div>
);
